import Typography from "../../components/Typography/Typography";

export default function BlogCard({ blogItem }) {
    return (
        <div className="flex flex-col gap-3 cursor-pointer">
            <img
                className="w-full"
                src={blogItem.image}
                alt={`Athena ${blogItem.title}`}
            />
            <div className="flex flex-col gap-1">
            <Typography size="16" desktopSize="20" weight="sb" align="left">
                {blogItem.title}
            </Typography>
            <Typography size="12" desktopSize="16" weight="rg" align="left" color="gray-600">
                {blogItem.date} <span className="mx-2 text-gray-200">•</span> {blogItem.readTime}
            </Typography>
            </div>
        </div>
    )
}